/* eslint-disable react/prop-types */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import ds from 'designsystem';
import { inject, observer } from 'mobx-react';
import Slider from 'react-slick';
import Carousel from 'blocks/Carousel/Carousel';
import Fade from 'react-reveal/Fade';
import { FADE_VALUES } from 'animations/Animations';

import './sliderStyles.css';

/* Disable ESlint rule for this file */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable no-return-assign */
/* eslint react/no-array-index-key: "off" */

const CustomArrow = (props) => {
  const { styles, onClick } = props;
  return (
    <div
      className={styles}
      onClick={onClick}
      role="navigation"
    />
  );
};

const wrapperDivStyles = {
  width: '120%',
  margin: `${ds.get('metrics.l')} 0`,
  marginLeft: '-15%',
  overflow: 'hidden',
};

const Image = styled.img`
    width:100%;
    margin:0 auto;
    outline:none;
  `;

@inject('windowStore')
@observer
export default class BlogImageSlider extends Component {
  static mobileCarouselSettings = {
    swipe: true,
    slidesToShow: 1,
    dots: true,
    infinite: true,
    arrows: false,
    slidesToScroll: 1,
  }

  constructor(props) {
    super(props);
    this.state = {
      nav1: null,
      nav2: null,
    };
  }

  componentDidMount() {
    this.setState({
      nav1: this.slider1,
      nav2: this.slider2,
    });
  }

  render() {
    const {
      slides,
      windowStore,
    } = this.props;
    const { nav1, nav2 } = this.state;

    return (
      windowStore.isOnTablet
        ? (
          <Carousel blogArticle settings={BlogImageSlider.mobileCarouselSettings}>
            {slides.map((slide, index) => <Image key={index} src={windowStore.adjustImageSize(slide)} />)}
          </Carousel>

        ) : (
          <div style={wrapperDivStyles}>
            <Fade bottom distance={`${FADE_VALUES.BOX.LIGHT}`} delay={FADE_VALUES.DELAY.SMALL}>
              <Slider
                asNavFor={nav2}
                ref={slider => (this.slider1 = slider)}
                prevArrow={<CustomArrow styles="arrow prevArrow" />}
                nextArrow={<CustomArrow styles="arrow nextArrow" />}
                className="mainSlider"
              >
                {slides.map((slide, index) => <Image key={index} src={windowStore.adjustImageSize(slide)} />)}
              </Slider>
              {slides.length > 1 && (
                <Slider
                  asNavFor={nav1}
                  ref={slider => (this.slider2 = slider)}
                  slidesToShow={slides.length < 4 ? slides.length : 4}
                  swipeToSlide
                  focusOnSelect
                  centerMode
                  className="assistantSlider"
                >
                  {slides.map((slide, index) => <Image key={index} src={windowStore.adjustImageSize(slide)} />)}
                </Slider>
              )}
            </Fade>
          </div>
        )
    );
  }
}

BlogImageSlider.propTypes = {
  slides: PropTypes.arrayOf(PropTypes.string).isRequired,
};

CustomArrow.propTypes = {
  onClick: PropTypes.func,
  styles: PropTypes.string.isRequired,
};

CustomArrow.defaultProps = {
  onClick: () => {},
};



// WEBPACK FOOTER //
// ./src/kentico-blocks/BlogImageSlider/index.jsx